module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XVII",
      "title": "XVII"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HERE ARE SO MANY TO THANK")]), _vm._v(". My students in Philosophy of Religion in the spring term of 2019 and of 2020 have all played some part in research and review: Jonathan Smith, Chester Walker, Noah Perrault, Asher Thompson, Kedrick Bradley, Devonte Narde, Corey Walton, Mike Consiglio, and Scout Powell. Thank you! Thanks to my student Israel Healy for doing the contents page. Don Zeyl, Andrew Loke, David Baggett, Gary Habermas, Alexander Pruss, Jeffrey Koperski, James East, and Lad Sessions, as well as my former assistants Max Andrews and Caleb Brown, have read parts of this and given me comments. My colleagues and friends Ed Martin and Eberhard Bertsch read the whole manuscript. I’m so grateful to all of them. Whatever mistakes remain are mine.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Most of all, I’m grateful to my wife, Jean, who spent endless hours typing in longer quotes, and just putting up with a year’s obsession—our fiftieth year together, actually. I might wish for fifty more like this, but we will have so many more than that together—endlessly more.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0